import React from 'react';
import { Card, HeadingText, styled } from '@leagueplatform/genesis-core';
import { ListItem } from '@leagueplatform/genesis-core-alpha';

const List = styled('ul', {
  padding: 0,
});

interface HealthGoalsProps {
  heading: string;
  backgroundColor?: string;
  items: {
    icon: string;
    body: string;
  }[];
}

export const HealthGoals = ({
  heading,
  backgroundColor = 'transparent',
  items,
}: HealthGoalsProps) => (
  <Card.Flat
    css={{
      backgroundColor,
      padding: '$oneAndHalf',
      borderRadius: 'calc($medium + $thick)',
    }}
    data-testid="healthGoalsContainer"
  >
    <HeadingText size="md" level="3" css={{ marginBottom: '$one' }}>
      {heading}
    </HeadingText>
    <List>
      {items.map((item) => (
        <ListItem label={item.body} size="compact" icon={item.icon} />
      ))}
    </List>
  </Card.Flat>
);
